import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router";

import { MainLayout } from "layouts";
import {
  TermsServiceComponent,
  TermsPrivacyComponent,
  TermsPrivacyAgreeComponent,
  TermsMarketingComponent,
} from "components/entrance/signup";

const Service = () => {
  const location = useLocation();
  const { label, name } = location.state;

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{
        withBackButton: true,
        centerTitle: label,
      }}
    >
      <Wrapper>
        {name === "service" && <TermsServiceComponent header={false} />}
        {name === "privacy" && <TermsPrivacyComponent header={false} />}
        {name === "privacyAgree" && (
          <TermsPrivacyAgreeComponent header={false} />
        )}
        {name === "marketing" && <TermsMarketingComponent header={false} />}
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 16px 0;
`;

export default Service;
